import { useLocation, useNavigate, useSearchParams, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import LoadingPage from "../../components/Loading";
import SystemPushNotification from "./components/SystemPushNotification";
import SystemInAppNotification from "./components/SystemInAppNotification";

const TABS = ['手機通知','應用程式內通知',
    //'投訴管理'
    //'應用程式設定','優惠代碼管理','聯絡我們管理','評論管理'
];

function Page(props) {
    const navigate = useNavigate();
    const { id } = useParams();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams();
    const [tab, setTab] = useState(TABS[0])



    return (
        <div className="relative h-full w-full flex flex-col items-start justify-start bg-[#ddd] pb-[16px] gap-[16px]" style={{ overflowY: 'auto' }}>

            <div className="w-full flex flex-row gap-[16px] flex-wrap p-[16px] relative">
                {TABS.map((item, index) =>
                    <div key={item} className="flex flex-row items-center justify-center cursor-pointer z-[2]" style={{ fontWeight: item === tab ? '700' : '400', fontSize: '16px', color: item === tab ? '#0F737E' : '#00000099', padding: '8px 16px', borderBottom: item === tab ? '2px solid #0F737E' : 'none' }} onClick={() => { setTab(item) }}>
                        {item}
                    </div>
                )}
                <div className="absolute top-0 left-0 right-0 bottom-0 z-[1]" style={{ background: 'linear-gradient(180deg, rgba(230, 235, 237, 0.3) 28.5%, #FFFFFF 100%)' }} />
            </div>
            

            {tab === '手機通知' && <SystemPushNotification/>}
            {tab === '應用程式內通知' && <SystemInAppNotification/>}


            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)
